export const RECORDING_SERVER_URL = process.env.REACT_APP_RECORDING_SERVER_URL || 'wss://recording.pod.nimey-local.de'